export default {
  // AboutPage - About Us Page
  aboutUs: 'About Us',
  aboutUsSubtitle: 'A story born from a journey, a system built for the ones we love',

  ourStory: 'Our Story',
  howItAllBegan: 'It All Started with a Trip',
  storyParagraph1: 'The night before departure, we sat at the table staring at a sheet of paper covered in notes. Feeding times, portion sizes, treat restrictions, daily medications, the vet\'s number, emergency contacts... The list of things to tell the caregiver was far longer than we had imagined. Even after writing it all down, we still felt uneasy — would they really remember all of this?',
  storyParagraph2: 'During the trip, messages kept coming in: "How many pieces of kibble does she get?" "Is that medication morning or evening?" "She\'s not eating — is that normal?" Every notification made it hard to put the phone down, yet time zones and a packed itinerary made it impossible to reply straight away. The worry made it hard to enjoy the journey; the constant questions put pressure on the caregiver too.',
  storyParagraph3: 'That\'s when the idea took shape: what if there were one place where everything about your pet was organised and ready to view at any time — no guessing, no repeated questions, no risk of getting it wrong? And so this platform was born. Tailored to each individual pet, with information that is always 100% accurate and shareable with a single link. Whether you\'re travelling abroad or simply leaving your pet with a friend, you can finally step away with genuine peace of mind — knowing your beloved companion is in the best possible hands.',

  storyHighlight1: 'No more hand-written care notes before every trip',
  storyHighlight2: 'Caregivers can check everything instantly, reducing repeated questions',
  storyHighlight3: '100% accurate information — peace of mind for owners, the best care for pets',
  storyImageCaption1: 'Every journey, worry-free',
  storyImageCaption2: 'They wait at home — you travel in peace',

  founded: 'Est.',
  uniqueStatValue: 'One of a Kind',
  uniqueStat: 'Every profile is personalised',
  alwaysThereValue: '24/7',
  alwaysThere: 'Their info, always with you',

  ourMission: 'Our Mission',
  whyWeExist: 'Why We Exist',
  missionStatement: 'We are dedicated to making pet care simpler and more accurate through innovative technology, helping every pet owner and caregiver provide the highest quality care, ensuring every furry friend enjoys a happy and secure life.',
  betterCare: 'Superior Care',
  betterCareDesc: 'Help pet owners provide the most professional and thoughtful care',
  peaceMind: 'Peace of Mind',
  peaceMindDesc: 'Keep you informed about your pet\'s health and care status at all times',
  buildCommunity: 'Build Community',
  buildCommunityDesc: 'Connect pet lovers with professional caregivers',

  ourValues: 'Our Values',
  whatDrivesUs: 'Core Principles That Drive Us',
  valuesDescription: 'These core values guide every decision and action we take.',
  excellence: 'Pursuit of Excellence',
  excellenceDesc: 'We continuously refine our service quality to provide the best user experience',
  innovation: 'Embrace Innovation',
  innovationDesc: 'We embrace innovative thinking to find better solutions',
  reliability: 'Trustworthy',
  reliabilityDesc: 'We provide reliable and stable services you can confidently depend on',

  joinOurMission: 'Join Our Mission',
  joinMissionDescription: 'Become part of our community and help create a better future for pet care together.',
  getStarted: 'Get Started',

  // ContactPage
  contactUs: 'Contact Us',
  contactUsSubtitle: 'Have questions or suggestions? We\'d love to hear from you.',
  technicalSupport: 'Technical Support',
  homyTechLimited: 'Homy Tech Limited',
  homyTechDescription: 'We are an innovative company focused on pet technology, dedicated to providing the most thoughtful and professional digital solutions for pet owners and caregivers.',
  contactByEmail: 'Contact Us by Email',
  clickToSendEmail: 'Click to send an email, and we\'ll get back to you as soon as possible',
  responseTime: 'Thoughtful Response',
  responseTimeDesc: 'Every message is carefully read, and we do our best to reply within a reasonable timeframe',
  privacyProtection: 'Privacy Protection',
  privacyProtectionDesc: 'Your data will be strictly protected and never disclosed',
  carefulReply: 'Human Touch',
  carefulReplyDesc: 'Every email is carefully read and replied to by a real person',
  faq: 'FAQ',
  commonQuestions: 'Frequently Asked Questions',
  faqSubtitle: 'Here are some of the most commonly asked questions',
  faq1Question: 'How do I get started with this platform?',
  faq1Answer: 'Simply register for a free account and create your pet\'s profile. The whole process is very simple and takes just a few minutes.',
  faq2Question: 'Is my data secure?',
  faq2Answer: 'Absolutely. We use industry-standard encryption technology to protect your data, and we will never share your personal information with third parties.',
  faq3Question: 'How many people can I share with?',
  faq3Answer: 'You can share your pet\'s profile with any number of caregivers or family members. Each sharing link is independent and secure.',
  faq4Question: 'What if I forget my password?',
  faq4Answer: 'Click "Forgot Password" on the login page, enter your registered email, and we will send you a password reset link.',
  moreQuestions: 'Have More Questions?',
  moreQuestionsDesc: 'If you have any other questions, feel free to contact us via email anytime',
  sendEmailNow: 'Send Email Now',

  // SettingsPage
  settingsTitle: 'Settings',
  settingsDescription: 'Manage your account settings and preferences',
  accountSettings: 'Account Settings',
  changePassword: 'Change Password',
  accountInfoSubtitle: 'Update your personal information',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  emailPlaceholder: 'Your email',
  emailCannotBeChanged: 'Email cannot be changed',
  phoneNumber: 'Phone Number',
  phonePlaceholder: 'Your phone number',
  saveChanges: 'Save Changes',
  saving: 'Saving...',
  changePasswordSubtitle: 'Update your account password',
  currentPassword: 'Current Password',
  enterCurrentPassword: 'Enter current password',
  newPassword: 'New Password',
  enterNewPassword: 'Enter new password',
  confirmPassword: 'Confirm Password',
  confirmNewPassword: 'Enter new password again',
  updatePasswordButton: 'Update Password',
  updating: 'Updating...',
  passwordRequirements: 'Password Requirements',
  passwordMinLength: 'At least 6 characters',
  passwordMixCase: 'Contains uppercase letter',
  passwordMismatch: 'Passwords do not match',
  passwordsMatch: 'Passwords match',
  accountUpdated: 'Account information updated',
  passwordUpdated: 'Password updated',
  fetchError: 'Failed to load data',
  updateError: 'Update failed',
  userNotFound: 'User not found',
  currentPasswordRequired: 'Please enter current password',
  currentPasswordIncorrect: 'Current password is incorrect',
  passwordTooShort: 'Password is too short',
  samePasswordError: 'New password cannot be the same as old password',
  rateLimitError: 'Too many attempts, please try again later',
  networkError: 'Network error, please check your connection',
  logout: 'Logout',
  logoutToLogin: 'Logout and return to login page',
  loggingOut: 'Logging out...',
  redirectingToLogin: 'Redirecting to login page...',
  refreshingPage: 'Refreshing page...',
  loading: 'Loading...',

  // PrivacyPage
  privacyPolicyTitle: 'Privacy Policy',
  privacyPolicySubtitle: 'We value your privacy and protect your personal information',
  lastUpdated: 'Last Updated',
  effectiveDate: 'December 20, 2025',
  privacyIntroTitle: 'Introduction',
  privacyIntro: 'This privacy policy explains how we collect, use, and protect your personal information.',
  dataCollectionTitle: 'Information We Collect',
  dataCollectionDesc: 'We collect the following types of information:',
  personalInfoTitle: 'Personal Information',
  personalInfoItem1: 'Name and email address',
  personalInfoItem2: 'Phone number (optional)',
  personalInfoItem3: 'Account credentials',
  petInfoTitle: 'Pet Information',
  petInfoItem1: 'Pet name, breed, age',
  petInfoItem2: 'Health records and vaccine information',
  petInfoItem3: 'Care instructions and notes',
  petInfoItem4: 'Pet photos',
  technicalDataTitle: 'Technical Data',
  technicalDataItem1: 'IP address and browser information',
  technicalDataItem2: 'Usage patterns and preferences',
  technicalDataItem3: 'Cookies and similar technologies',
  dataUsageTitle: 'How We Use Information',
  dataUsageDesc: 'We use collected information for:',
  dataUsageItem1: 'Providing and improving our services',
  dataUsageItem2: 'Personalizing your experience',
  dataUsageItem3: 'Sending important notifications and updates',
  dataUsageItem4: 'Responding to your inquiries',
  dataUsageItem5: 'Maintaining platform security',
  dataUsageItem6: 'Complying with legal obligations',
  dataUsageItem7: 'Analyzing and improving service quality',
  dataSecurityTitle: 'Data Security',
  dataSecurityDesc: 'We take multiple security measures to protect your data:',
  dataSecurityItem1: 'Encrypted transmission and storage',
  dataSecurityItem2: 'Regular security audits',
  dataSecurityItem3: 'Strict access controls',
  dataSecurityItem4: 'Employee training and confidentiality agreements',
  dataSecurityItem5: 'Timely security updates',
  dataSecurityNote: 'While we strive to protect your data, no system is 100% secure.',
  dataSharingTitle: 'Information Sharing',
  dataSharingDesc: 'We do not sell your personal information. We may share information in the following cases:',
  dataSharingItem1: 'With your consent',
  dataSharingItem2: 'With service providers (such as cloud storage)',
  dataSharingItem3: 'To comply with legal requirements',
  dataSharingItem4: 'To protect our rights and safety',
  yourRightsTitle: 'Your Rights',
  yourRightsDesc: 'You have the following rights regarding your personal information:',
  yourRightsItem1: 'Access your data',
  yourRightsItem2: 'Correct incorrect data',
  yourRightsItem3: 'Delete your data',
  yourRightsItem4: 'Restrict data processing',
  yourRightsItem5: 'Data portability',
  yourRightsItem6: 'Object to data processing',
  yourRightsNote: 'To exercise these rights, please contact our support team.',
  dataRetentionTitle: 'Data Retention',
  dataRetentionDesc: 'We retain your data for as long as:',
  dataRetentionItem1: 'Your account is active',
  dataRetentionItem2: 'Required to provide services',
  dataRetentionItem3: 'Required by law or regulation',
  dataRetentionItem4: 'To resolve disputes and enforce agreements',
  dataRetentionNote: 'You can delete your account and data at any time.',
  cookiesTitle: 'Cookies and Tracking Technologies',
  cookiesDesc: 'We use cookies and similar technologies to:',
  cookiesItem1: 'Remember your preferences',
  cookiesItem2: 'Analyze website usage',
  cookiesItem3: 'Improve user experience',
  cookiesNote: 'You can manage cookie preferences through your browser settings.',
  childrensPrivacyTitle: 'Children\'s Privacy',
  childrensPrivacyDesc: 'Our services are not directed to children under 13. We do not knowingly collect personal information from children.',
  internationalTransfersTitle: 'International Data Transfers',
  internationalTransfersDesc: 'Your data may be transferred to servers outside your country/region. We ensure appropriate safeguards are in place.',
  policyChangesTitle: 'Policy Changes',
  policyChangesDesc: 'We may update this privacy policy from time to time. We will notify you of any significant changes via email or platform notification.',
  contactInfoTitle: 'Contact Information',
  contactInfoDesc: 'If you have any questions about this privacy policy, please contact us:',
  contactEmail: 'Email',
  contactEmailValue: 'info@homy.hk',
  viewTerms: 'View Terms of Service',

  // TermsPage
  termsOfServiceTitle: 'Terms of Service',
  termsOfServiceSubtitle: 'Terms and conditions for using our services',
  termsIntroTitle: 'Acceptance of Terms',
  termsIntro: 'By using our services, you agree to these terms. Please read carefully.',
  serviceDescriptionTitle: 'Service Description',
  serviceDescriptionDesc: 'Pet Care Platform provides the following services:',
  serviceDescriptionItem1: 'Pet information management',
  serviceDescriptionItem2: 'Health record tracking',
  serviceDescriptionItem3: 'Care instruction sharing',
  serviceDescriptionItem4: 'Veterinarian information storage',
  serviceDescriptionItem5: 'Reminders and notifications',
  userAccountTitle: 'User Account',
  userAccountDesc: 'To use our services, you need to:',
  userAccountItem1: 'Create an account and provide accurate information',
  userAccountItem2: 'Protect your account credentials',
  userAccountItem3: 'Be responsible for activities under your account',
  userAccountItem4: 'Notify us of any unauthorized use',
  userAccountItem5: 'Be at least 18 years old or have parental consent',
  userAccountNote: 'You are responsible for maintaining account security.',
  userResponsibilitiesTitle: 'User Responsibilities',
  userResponsibilitiesDesc: 'When using our services, you agree to:',
  userResponsibilitiesItem1: 'Provide accurate and up-to-date information',
  userResponsibilitiesItem2: 'Comply with all applicable laws',
  userResponsibilitiesItem3: 'Respect the rights of other users',
  userResponsibilitiesItem4: 'Not abuse or misuse the services',
  userResponsibilitiesItem5: 'Back up your important data',
  userResponsibilitiesItem6: 'Be responsible for content you upload',
  prohibitedActivitiesTitle: 'Prohibited Activities',
  prohibitedActivitiesDesc: 'You must not:',
  prohibitedActivitiesItem1: 'Violate any laws or regulations',
  prohibitedActivitiesItem2: 'Infringe on others\' rights',
  prohibitedActivitiesItem3: 'Upload malware or viruses',
  prohibitedActivitiesItem4: 'Attempt unauthorized access',
  prohibitedActivitiesItem5: 'Interfere with service operations',
  prohibitedActivitiesItem6: 'Sell or transfer your account',
  intellectualPropertyTitle: 'Intellectual Property',
  intellectualPropertyDesc: 'Our services are protected by intellectual property laws:',
  intellectualPropertyItem1: 'We own all rights to the platform',
  intellectualPropertyItem2: 'You retain ownership of your content',
  intellectualPropertyItem3: 'You grant us a license to use your content',
  intellectualPropertyItem4: 'Do not use our trademarks without authorization',
  intellectualPropertyNote: 'Content you upload remains yours, but you grant us a license to use it to provide services.',
  dataOwnershipTitle: 'Data Ownership',
  dataOwnershipDesc: 'Regarding your data:',
  dataOwnershipItem1: 'You own all data you upload',
  dataOwnershipItem2: 'You can export or delete your data at any time',
  dataOwnershipItem3: 'We do not claim ownership of your content',
  dataOwnershipItem4: 'After account deletion, your data will be permanently deleted',
  serviceAvailabilityTitle: 'Service Availability',
  serviceAvailabilityDesc: 'Regarding service availability:',
  serviceAvailabilityItem1: 'We strive to keep services running but do not guarantee 100% uptime',
  serviceAvailabilityItem2: 'There may be planned or unplanned downtime',
  serviceAvailabilityItem3: 'We may modify or discontinue services at any time',
  serviceAvailabilityItem4: 'We are not responsible for losses caused by service interruptions',
  disclaimerTitle: 'Disclaimer',
  disclaimerDesc: 'Our services are provided "as is":',
  disclaimerItem1: 'No guarantee of error-free or uninterrupted service',
  disclaimerItem2: 'No guarantee of result accuracy',
  disclaimerItem3: 'Does not provide veterinary or medical advice',
  disclaimerItem4: 'Users should consult professionals',
  disclaimerItem5: 'We are not responsible for user decisions',
  limitationOfLiabilityTitle: 'Limitation of Liability',
  limitationOfLiabilityDesc: 'To the maximum extent permitted by law:',
  limitationOfLiabilityItem1: 'We are not responsible for any indirect losses',
  limitationOfLiabilityItem2: 'Our liability is limited to fees you paid',
  limitationOfLiabilityItem3: 'Some jurisdictions may not allow these limitations',
  terminationTitle: 'Termination',
  terminationDesc: 'Regarding account termination:',
  terminationItem1: 'You can close your account at any time',
  terminationItem2: 'We may suspend or terminate accounts for violations',
  terminationItem3: 'After termination, your data will be deleted',
  terminationItem4: 'Certain terms remain effective after termination',
  changestoTermsTitle: 'Changes to Terms',
  changestoTermsDesc: 'We may update these terms:',
  changestoTermsItem1: 'We will notify you of significant changes',
  changestoTermsItem2: 'Continued use indicates acceptance of new terms',
  changestoTermsItem3: 'If you disagree, you should stop using the services',
  governingLawTitle: 'Governing Law',
  governingLawDesc: 'These terms are governed by:',
  governingLawItem1: 'Hong Kong law applies',
  governingLawItem2: 'Disputes will be resolved in Hong Kong courts',
  governingLawItem3: 'Both parties waive jury trial rights',
  contactForTermsTitle: 'Contact Us',
  contactForTermsDesc: 'If you have any questions about these terms, please contact us:',
  contactForTermsEmail: 'info@homy.hk',
  viewPrivacy: 'View Privacy Policy',
};